import { PaymentsList } from '@/components/payments';

export default function PaymentsPage() {
    return (
        <PaymentsList/>
    )
}